module.exports = "../images/icon-activities.png?v=721acd1";